import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /\.json$/
  );
  const messages = {};
  for (let key of locales.keys()) {
    // Extract locale from path like "./en.json" or "./subdir/en.json"
    const locale = key.replace(/^.*\//, '').replace(/\.json$/, '');
    if (locale) {
      messages[locale] = locales(key);
    }
  }

  return messages;
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  dateTimeFormats: {
    en: {
      long: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    pt: {
      long: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  },
  messages: loadLocaleMessages()
});
